import React from "react";
import { Dimmer, Loader, Segment } from "semantic-ui-react";

export default () => (
  <div>
    <Segment style={{ padding: "35vh 0" }}>
      <Dimmer active>
        <Loader>Looking out for Zeds... maybe try a page refresh?</Loader>
      </Dimmer>
    </Segment>
  </div>
);
